import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline, secondaryFill, secondaryOutline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M73.9841 41.3522C73.9841 41.3522 60.4241 34.4622 56.3741 29.7322C51.8741 24.4722 52.0741 1.83228 52.0741 1.83228H39.6541C39.6541 1.83228 39.9641 24.5822 35.3541 29.7322C30.4641 35.1922 17.7441 41.1522 17.7441 41.1522C23.9341 55.7322 36.3341 59.4523 45.8641 59.4523C55.3941 59.4523 67.7841 55.9322 73.9841 41.3522Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M87.5144 58.2422C85.9544 46.2322 82.3044 42.9922 77.6344 40.6422C75.3344 39.4822 60.8044 31.7622 60.8044 31.7622C60.8044 31.7622 55.8944 38.7022 46.2144 38.7022C36.5344 38.7022 30.9144 31.7622 30.9144 31.7622C30.9144 31.7622 16.4744 39.4322 14.0744 40.6422C9.4044 42.9922 5.8444 46.6222 4.1944 58.2422C2.7144 69.3022 2.27441 72.0622 2.27441 72.0622H89.4244C89.4344 72.0622 88.8144 68.5422 87.5144 58.2422Z"
        fill={secondaryFill}
        stroke={secondaryOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M24.9746 34.5723C24.9746 34.5723 31.2246 44.8123 44.9546 44.8123C60.1446 44.8123 66.7546 34.5723 66.7546 34.5723"
        stroke={secondaryOutline}
        fill="none"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M17.2148 37.7823C13.8048 32.5023 20.9548 21.4923 25.1448 18.4023C29.3248 15.3223 37.0348 15.1023 37.0348 15.1023C37.0348 15.1023 36.5948 25.5623 33.0748 29.3023C33.0748 29.3023 39.4648 39.3223 39.7948 46.2523C40.1248 53.1923 40.8948 72.1223 40.8948 72.1223H1.9248C1.9248 72.1223 3.78481 51.6923 7.86481 45.9223C11.0548 41.4223 17.2148 37.7823 17.2148 37.7823Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M33.185 18.7422C31.915 19.0522 30.6249 19.3922 29.5349 19.9922C29.0149 20.2722 28.495 20.6922 28.465 21.0722C28.405 21.4422 28.6649 22.0522 28.9449 22.5722C29.5549 23.6422 30.3149 24.7022 31.0749 25.7522L33.345 28.9622C34.815 31.1522 36.1949 33.4322 37.2649 35.8622C38.3449 38.2822 39.1449 40.8722 39.3549 43.5022C37.7249 38.4822 35.0349 34.0922 32.1049 29.7922C30.6849 27.6022 29.0749 25.5622 27.8949 23.0622C27.7549 22.7422 27.6249 22.4122 27.5349 22.0422C27.4449 21.6822 27.3749 21.2722 27.5149 20.8122C27.6549 20.3622 27.965 20.0222 28.275 19.8122C28.585 19.5822 28.9049 19.4322 29.2349 19.3122C30.5349 18.8622 31.855 18.7322 33.185 18.7422Z"
        fill={outline}
      />
      <path
        d="M18.4246 27.6523C17.9746 29.1123 17.6046 30.5824 17.4246 32.0524C17.3346 32.7824 17.2646 33.5124 17.3146 34.2224C17.3646 34.9224 17.4646 35.6224 17.7246 36.1324C18.2546 37.1924 19.4846 37.9024 20.7946 38.4224C22.1146 38.9624 23.5546 39.3723 25.0046 39.7723C27.8846 40.6323 30.9546 41.4424 33.6346 43.2624C34.9646 44.1624 36.1646 45.3524 36.8646 46.8324C37.5646 48.2924 37.7846 49.9224 37.5746 51.4324C37.3446 49.9124 36.8646 48.4824 36.0146 47.3224C35.2146 46.1424 34.0546 45.2824 32.8046 44.5824C31.5446 43.9024 30.1846 43.3724 28.7646 42.9424C27.3546 42.4924 25.9146 42.0924 24.4346 41.6924C22.9746 41.2424 21.4846 40.8223 20.0146 40.1523C19.2846 39.8123 18.5646 39.4024 17.8846 38.8724C17.2046 38.3524 16.5846 37.6224 16.2746 36.7424C15.6846 34.9524 16.0346 33.3623 16.4446 31.8423C16.9346 30.3523 17.5846 28.9423 18.4246 27.6523Z"
        fill={outline}
      />
      <path d="M9.73438 44.5024L19.7444 72.1324" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path
        d="M37.0352 48.5723L38.1352 72.0222"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M36.8151 52.0923H5.91507L4.70508 55.3923"
        stroke={outline}
        fill="none"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M37.4746 62.3323H3.49466L3.01465 66.4122"
        stroke={outline}
        fill="none"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M27.3447 17.4224C27.3447 17.4224 23.7047 19.0724 25.4747 23.1424C27.6747 28.2024 38.1347 36.3524 39.2347 47.3624"
        stroke={outline}
        fill="none"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M74.4652 37.7823C77.8752 32.5023 70.7252 21.4923 66.5352 18.4023C62.3552 15.3223 54.6452 15.1023 54.6452 15.1023C54.6452 15.1023 55.0852 25.5623 58.6052 29.3023C58.6052 29.3023 52.2152 39.3223 51.8852 46.2523C51.5552 53.1923 50.7852 72.1223 50.7852 72.1223H89.7552C89.7552 72.1223 87.8952 51.6923 83.8152 45.9223C80.6252 41.4223 74.4652 37.7823 74.4652 37.7823Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M58.5047 18.7422C59.8247 18.7322 61.1547 18.8622 62.4647 19.3222C62.7947 19.4522 63.1147 19.5922 63.4247 19.8222C63.7347 20.0322 64.0447 20.3722 64.1847 20.8222C64.3247 21.2822 64.2547 21.7022 64.1647 22.0522C64.0747 22.4222 63.9447 22.7522 63.8047 23.0722C62.6247 25.5722 61.0147 27.6122 59.5947 29.8022C56.6647 34.1022 53.9747 38.4922 52.3447 43.5122C52.5547 40.8722 53.3547 38.2922 54.4347 35.8722C55.5047 33.4322 56.8947 31.1622 58.3547 28.9722L60.6247 25.7622C61.3947 24.7122 62.1447 23.6523 62.7547 22.5823C63.0347 22.0623 63.2947 21.4523 63.2347 21.0823C63.2047 20.7023 62.6847 20.2922 62.1647 20.0022C61.0547 19.3922 59.7747 19.0522 58.5047 18.7422Z"
        fill={outline}
      />
      <path
        d="M73.2552 27.6523C74.1052 28.9323 74.7453 30.3423 75.2153 31.8423C75.6253 33.3523 75.9752 34.9524 75.3852 36.7424C75.0652 37.6224 74.4453 38.3524 73.7753 38.8724C73.0953 39.4024 72.3753 39.8223 71.6453 40.1523C70.1753 40.8223 68.6852 41.2424 67.2252 41.6924C65.7552 42.0924 64.3053 42.4924 62.8953 42.9424C61.4753 43.3724 60.1152 43.9024 58.8552 44.5824C57.6152 45.2724 56.4553 46.1324 55.6453 47.3224C54.8053 48.4824 54.3153 49.9124 54.0853 51.4324C53.8653 49.9124 54.0953 48.2924 54.7953 46.8324C55.4953 45.3624 56.7053 44.1624 58.0253 43.2624C60.7053 41.4424 63.7753 40.6423 66.6553 39.7723C68.1053 39.3723 69.5453 38.9624 70.8653 38.4224C72.1753 37.8924 73.4053 37.1924 73.9353 36.1324C74.1953 35.6224 74.2953 34.9124 74.3453 34.2224C74.3953 33.5224 74.3353 32.7824 74.2353 32.0524C74.0753 30.5824 73.6952 29.1223 73.2552 27.6523Z"
        fill={outline}
      />
      <path d="M81.9555 44.5024L71.9355 72.1324" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path
        d="M54.6449 48.5723L53.5449 72.0222"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M54.8652 52.0923H85.9152L86.9152 55.1923"
        stroke={outline}
        fill="none"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M54.2051 62.3323H88.3251L88.6651 66.4122"
        stroke={outline}
        fill="none"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M64.3353 17.4224C64.3353 17.4224 67.9753 19.0724 66.2053 23.1424C64.0053 28.2024 53.5453 36.3524 52.4453 47.3624"
        stroke={outline}
        fill="none"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="45.8591"
          y1="42.9975"
          x2="45.8591"
          y2="8.96477"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
